import { React, useState } from 'react';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import PowerSettingsNewRoundedIcon from '@mui/icons-material/PowerSettingsNewRounded';
import RequestQuoteRoundedIcon from '@mui/icons-material/RequestQuoteRounded';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

import { Alerta } from '../../components/alerta';
import PageHeader from '../../components/pageHeader';
import SubmitButton from '../../components/submitButton';
import { fetchFlask } from '../../utils/fetchFlask';

const DesligamentoDefinitivo = () => {
    const [ccs, setCCs] = useState('');
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [openAlerta, setOpenAlerta] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    async function submitFinalizarCC (e) {
        e.preventDefault();
        setIsSubmit(true);

        const body = JSON.stringify({ ccs: ccsList });
        try {
            const response = await fetchFlask('desligamentoDefinitivo', body);
            setMessage(response.message);
            setStatus(response.status);
            setOpenAlerta(true);
            if (response.status === 'success') {
                setCCs('');
            }
        } finally {
            setIsSubmit(false);
        }
    }

    const ccsList = ccs
        .split(/[\s,;]+/)
        .map((cc) => cc.trim())
        .filter(Boolean);
    const completedFields = [ccsList.length > 0].filter(Boolean).length;

    return (
        <Box className='mainBox ui-workflow-page'>
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />
            <PageHeader>
                Desligamento Definitivo
            </PageHeader>

            <form action='' method='POST' id='formDesligamentoDefinitivo' onSubmit={submitFinalizarCC} className='ui-workflow-layout'>
                <Box className='ui-workflow-workspace'>
                    <Box className='ui-workflow-intro'>
                        <Box>
                            <h2>Solicitação de desligamento da unidade</h2>
                        </Box>
                        <p>
                            Informe as contas contrato para solicitar à Neoenergia o desligamento definitivo das unidades consumidoras.
                        </p>
                    </Box>

                    <Box className='ui-workflow-panel'>
                        <Box className='ui-heading'>
                            <RequestQuoteRoundedIcon />
                            <Box>
                                <span>Etapa única</span>
                                <strong>Identificação das unidades</strong>
                            </Box>
                        </Box>

                        <Box className='ui-input-strip'>
                            <BoltRoundedIcon />
                            <TextField
                                required
                                label='Contas contrato'
                                id='ccs'
                                multiline
                                minRows={7}
                                maxRows={14}
                                value={ccs}
                                onChange={(e) => setCCs(e.target.value)}
                                placeholder='Uma CC por linha, ou separadas por vírgula'
                            />
                        </Box>
                    </Box>

                    <Box className='ui-impact'>
                        <PowerSettingsNewRoundedIcon />
                        <Box>
                            <strong>Solicitação junto à distribuidora</strong>
                            <span>A operação encaminha a lista de contas contrato para abertura dos pedidos de desligamento definitivo na Neoenergia.</span>
                        </Box>
                    </Box>

                    <Box className='ui-rail'>
                        <Box>
                            <BoltRoundedIcon />
                            <span>Unidades</span>
                            <strong>
                                {ccsList.length === 0 ? 'Contas contrato pendentes' : `${ccsList.length} identificada${ccsList.length === 1 ? '' : 's'}`}
                            </strong>
                        </Box>
                        <Box>
                            <PowerSettingsNewRoundedIcon />
                            <span>Destino</span>
                            <strong>Neoenergia</strong>
                        </Box>
                    </Box>
                </Box>

                <Box className='ui-workflow-summary'>
                    <Box className='ui-heading ui-heading-divided'>
                        <FactCheckRoundedIcon />
                        <Box>
                            <span>Resumo</span>
                            <strong>Revisão da solicitação</strong>
                        </Box>
                    </Box>

                    <Box className='ui-workflow-summary-list'>
                        <Box>
                            <span>Contas contrato</span>
                            <strong className={ccsList.length === 0 ? 'is-empty' : undefined}>
                                {ccsList.length === 0 ? 'Não informadas' : `${ccsList.length} identificada${ccsList.length === 1 ? '' : 's'}`}
                            </strong>
                        </Box>
                        <Box>
                            <span>Operação</span>
                            <strong>Desligamento definitivo</strong>
                        </Box>
                        <Box>
                            <span>Distribuidora</span>
                            <strong>Neoenergia</strong>
                        </Box>
                    </Box>

                    <Box className='ui-attention'>
                        <WarningAmberRoundedIcon />
                        <p>
                            Revise a lista antes de enviar. A solicitação representa o desligamento definitivo das unidades junto à distribuidora.
                        </p>
                    </Box>

                    <Box className='ui-attention is-ok ui-completion'>
                        <AssignmentTurnedInRoundedIcon />
                        <Box>
                            <span>Campos críticos</span>
                            <strong>{completedFields}/1 preenchido</strong>
                        </Box>
                    </Box>

                    <SubmitButton isSubmit={isSubmit} startIcon={<SendRoundedIcon />}>
                        Solicitar Desligamento
                    </SubmitButton>
                </Box>
            </form>
        </Box>
    );
};

export default DesligamentoDefinitivo;
